import { createContext } from "react";

const DF_CO0008Context = createContext();

export { DF_CO0008Context };